import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { isBrowser, isMobile } from 'react-device-detect';
import { dynamicAssets } from '../../../../utilities/helpers';
import { featuresScreens } from '../../../../utilities/constants';

const PaymentBanner = () => {
  const { t: translate } = useTranslation();

  const history = useHistory();
  const handleOnClickAction = () => {
    history.push('/dashboard/card/payment-banner-info', {
      initScreen: featuresScreens.SELECT_WALLET,
    });
  };

  const textColors = useMemo(() => {
    if (process.env.REACT_APP_FLAVOR === '1inch') {
      return {
        title: 'text-dark',
        subTitle: 'text-dard opacity-50',
      };
    }
    return {
      title: 'text-disabled',
      subTitle: 'text-disabled',
    };
  }, []);

  return (
    <div
      className={`position-relative payment-banner my-4 w-100 p-4 rounded-extra cursor-pointer ${
        isMobile && 'payment-banner-mobile mt-2 mb-2 pt-3 px-2'
      }`}
      tabIndex={-1}
      role="presentation"
      onClick={handleOnClickAction}>
      {isBrowser && (
        <img
          className="payment-banner-image rounded-extra"
          src={dynamicAssets('./assets/images/payment-banner.png')}
          width="100%"
          height="100%"
          alt="plus"
        />
      )}
      {isBrowser && (
        <>
          <div className="w-75 d-flex flex-column align-items-start pe-4">
            <p className={`text-f4 ${textColors?.title} text-bold`}>
              {translate('payment_banner_title')}
            </p>
            <p className={`text-f6 ${textColors?.subTitle} mt-2 text-bold`}>
              {translate('payment_banner_subtitle')}
            </p>
          </div>
          <div className="d-flex justify-content-start align-items-center mt-4">
            <div className="position-relative payment-banner-button">
              <img
                className="payment-banner-button-image"
                src="./assets/images/apple-pay.svg"
                width="100%"
                height="100%"
                alt="plus"
              />
            </div>
            <div className="position-relative payment-banner-button ms-2">
              <img
                className="payment-banner-button-image"
                src="./assets/images/google-pay.svg"
                width="100%"
                height="100%"
                alt="plus"
              />
            </div>
          </div>
        </>
      )}
      {isMobile && (
        <div className="d-flex flex-row align-items-center w-100">
          <p className={`text-f5 text-nowrap  ${textColors.title}`}>
            {translate('payment_banner_title_mobile')}
          </p>
          <div className="d-flex justify-content-start align-items-center ms-1">
            <div className="position-relative payment-banner-button">
              <img
                className="payment-banner-button-image"
                src="./assets/images/apple-pay.svg"
                width="100%"
                height="100%"
                alt="plus"
              />
            </div>
            <p className={`text-f5 ${textColors.title} ms-1`}>
              {translate('payment_banner_title_or_label')}
            </p>
            <div className="position-relative payment-banner-button ms-1">
              <img
                className="payment-banner-button-image"
                src="./assets/images/google-pay.svg"
                width="100%"
                height="100%"
                alt="plus"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentBanner;
